module.exports = __webpack_public_path__ + "img/logo_dk_top@3x.712b1bfb.png";